module.exports = __webpack_public_path__ + "assets/img/seal.52db2faf.png";